'use strict';

function LoanApplicationIncome() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._$classes = {
    form: '.js--loan-application-income-frequency-form',
    nextBtn: '.js--next',
    prevBtn: '.js--previous',
    inputPayFreq: '.js--pay-frequency'
  };

  this._fieldsInteractedWith = [];

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);
    this._submissionFlag = false;
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._$prevBtn = this._$node.find(this._$classes.prevBtn);
    this._$form = this._$node.find(this._$classes.form);
    this._$inputPayFreq = this._$node.find(this._$classes.inputPayFreq);

    this._setComputedVariables();
    this._setupEventHandlers();
    this._pushAnalytics();
    this._removeProgressLoader();
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('pay_frequency');

    if (this._submissionFlag === false) {
      this._pushAbandonmentData();
    }
    this._super();
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setComputedVariables = function () {
    var _this = this;

    var index = this._loanApplications[0]._getApplicationArrayIndex();

    this.presenter.addComputedVariable('pay_frequency', ['' + ('money.applications.loan_applications' + '[') + index + ']' + '.employment.pay_frequency'], function (payFrequency) {
      if (_this.presenter.getModelProperty('money._loanApplicationIncome.pay_frequency')) {
        payFrequency = _this.presenter.getModelProperty('money._loanApplicationIncome.pay_frequency');
      }

      switch (payFrequency) {
        case 'weekly':
          return '0';
        case 'bi_weekly':
          return '1';
        case 'semi_monthly':
          return '2';
        case 'monthly':
          return '3';
        default:
      }
    });
  };

  this._setupEventHandlers = function () {
    var _this2 = this;

    this._$form.on('submit', this._onValidateForm.bind(this));

    // On drop down select
    this._$form.on('change', function () {
      _this2._$inputPayFreq.mogo().hideErrorLabel();
      _this2._$inputPayFreq.mogo().hideError();
    });

    this._$prevBtn.on('click', function () {
      $('#LoanApplicationTray').mogo()._loanAppGoToPreviousStep();
    });

    // Form Abandonment Event listeners
    this._onFieldInteraction(this._$inputPayFreq);
  };

  this._onValidateForm = function (e) {
    if (e) e.preventDefault();
    var payFrequency = this._$inputPayFreq.val();

    if (!payFrequency) {
      this._$inputPayFreq.mogo().showErrorLabel();
      this._pushFormErrorAnalytics('next_pay_day'); // Not using BE to validate
      return;
    }
    this._setSubmissionFlag(true); // successful form submission flag
    this._submitAnalyticsForm();
    // Reset Model, if fields change .
    switch (payFrequency) {
      case '0':
        this._loanApplications[0].savePayFrequency('weekly');
        this._history.goToUrl(this.paths.loans.application_flow_income_weekly);
        break;
      case '1':
        this._loanApplications[0].savePayFrequency('bi_weekly');
        this._history.goToUrl(this.paths.loans.application_flow_income_bi_weekly);
        break;
      case '2':
        this._loanApplications[0].savePayFrequency('semi_monthly');
        this._history.goToUrl(this.paths.loans.application_flow_income_semi_monthly);
        break;
      case '3':
        this._loanApplications[0].savePayFrequency('monthly');
        this._history.goToUrl(this.paths.loans.application_flow_income_monthly);
        break;
    }
    return;
  };

  // Analytics
  this._setSubmissionFlag = function (boolean) {
    if (boolean !== null) this._submissionFlag = boolean;
  };

  this._pushAnalytics = function () {
    var url = window.location.pathname + (this.presenter.getModelProperty('money._loanApplicationEdit') === true ? '-edit' : '');

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._submitAnalyticsForm = function () {
    if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['Money-Form Submission-Payment Frequency Edit-null-Form']
      });
    } else {
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['Money-Form Submission-Payment Frequency-null-Form']
      });
    }
  };

  this._onFieldInteraction = function (domElement) {
    var elemName = domElement.attr('name');

    if (!elemName) return console.warn('Cannot find name in domElement, please pass through correct domElement');

    var elem = $('[name=\'' + elemName + '\']', this.node);
    var fieldComponent = $(elem).mogo();

    // From UI Schema Validation
    if (fieldComponent instanceof Select) {
      $(fieldComponent.containerDiv).on('enter', setInteractionField.bind(this, elem));
      $(fieldComponent.containerDiv).on('leave', setInteractionField.bind(this, elem));
      $(elem).on('focus', setInteractionField.bind(this, elem));
      $(elem).on('blur', setInteractionField.bind(this, elem));
    }

    function setInteractionField(elem, event) {
      $(elem)[0].dataset.interacted = true;
    }
  };

  this._findInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        this._fieldsInteractedWith.push(fields[i].name);
        fields[i].dataset.interacted = 'false'; // reset fields
      }
    }
  };

  this._pushAbandonmentData = function () {
    this._findInteractedFields();

    if (this._fieldsInteractedWith.length) {
      this.analytics.forcePushEvent('form-abandoned', {
        FormAbandoned: [this._fieldsInteractedWith.join(', ')]
      });
    }
  };

  this._pushFormErrorAnalytics = function (formId) {
    var formErrorId = null;
    if (formId) formErrorId = formId;

    this.analytics.forcePushEvent('form-errors', {
      FormErrors: [formErrorId]
    });
  };
}